import { createGlobalStyle } from 'styled-components';
import { fontSizes } from '@sorted/sorted-ui';

const GlobalStyle = createGlobalStyle`
	*, 
	*::before,
	*::after {	
		font-family: inherit; 
	}

	body {
		min-width: 360px;
		overflow-x: hidden;
	}
	
	#root,
	body,
	html {
		font-size: ${fontSizes.body};
		font-family: 'Circular Pro', Arial, sans-serif;
		margin: 0;
		padding: 0;		
	}
`;

export const sizing = {
	sideBarExpanded: '205px',
	sideBarCollapsed: '85px'
};

export default GlobalStyle;
